import React, { Component } from "react";
import AttendanceCard from "../../../Components/Attendance";
import Header from "../../../Components/MainLayout/Header";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../../../../global/unApi";
import Authorize from "../../../../global/Authorize";
import noData from "../../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class MarkAtt extends Component {
  state = {
    fakeData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    loading: true,
    student: [],
    data: "",
    attendence: [],
  };
  componentDidMount = () => {
    this.fetchData({
      student_class: this.props.match.params.classs,
      section: this.props.match.params.section,
      session: this.props.user.session.id,
      student__student_status: "currentlystudying",
      school: this.props.user.user.school.id,
    });
  };

  fetchData = (params = {}) => {
    axios
      .get("/api/session_student_shortinfo", { params: { ...params } })
      .then((res) => {
        this.setState({ student: res.data.results, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    if (this.props.user.staffData) {
      return (
        <Authorize roles={["IS_TEACHER"]} redirect to="/">
          <Header
            to="/profile"
            title={`${this.props.match.params.classname}-${this.props.match.params.sectionname} | ${this.props.match.params.date}`}
          />
          <div className="container col-12">
            {this.state.loading
              ? this.state.fakeData?.map((item, index) => {
                  return (
                    <div key={index} className="shadow-sm rounded p-2 mt-2">
                      <Skeleton width={150} />
                      <Skeleton />
                    </div>
                  );
                })
              : null}

            {this.state.student?.length !== 0 && this.state.loading === false
              ? this.state.student?.map((item) => {
                  return (
                    <div className="mt-2">
                      <AttendanceCard data={item} />
                    </div>
                  );
                })
              : null}

            {this.state.student?.length === 0 &&
            this.state.loading === false ? (
              <div className="px-5 py-5">
                <img className="w-100 mt-5" src={noData} alt="No Data Found" />
                <p className="text-center th-14 th-bold mt-5">
                  No Student Data!
                </p>
              </div>
            ) : null}
          </div>
        </Authorize>
      );
    } else {
      return (
        <div className="container py-5 text-center th-12">
          <p className="mb-0 th-bold">UnAuthorize</p>
        </div>
      );
    }
  }
}
export default withRouter(connect(mapStateToProps)(MarkAtt));
